import React from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'

import { Button, Animation } from 'components'
import { FilterOptions, SortOptions, GroupOptions } from 'features'
import { FaFilter, FaSortAmountUp, FaSortAmountUpAlt, FaObjectUngroup, FaSyncAlt } from 'react-icons/fa'
import { AnimateSharedLayout, AnimatePresence, motion } from 'framer-motion'

import { sortContext, filterContext, groupContext } from 'context'
import * as actionCreators from 'store/actions'

const buttonStyle = {
    backgroundColor: 'var(--secondary-color)',
    margin: '0 0.5rem 0 0',
}

const selectedStyle = {
    backgroundColor: 'var(--focus-color)',
    margin: '0 0.5rem 0 0',
    color: 'white',
    hoverColor: 'white'
}

const clearStyle = {
    backgroundColor: 'var(--primary-color)',
    margin: 0,
    boxShadowColor: 'transparent',
    padding: 0
}

const Container = styled.div`
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    padding: 0.5rem;
    align-items: center;
`

const ViewControl = props => {
    const {
        pageID
    } = props;
    const dispatch = useDispatch()
    const uid = useSelector(state => state.auth.uid)
    const sessionId = useSelector(state => state.content.sessionId)
    const data = useSelector((state) => state.db.present.data && state.db.present.data.toJS())
    const page = data['pages'][pageID]
    const grouped = page['group']
    const sorted = page['sort'] && page['sort']['value']
    const filtered = page['filters'] && page['filters'] && Object.values(page['filters']).some(value => value)
    const showClear = grouped || sorted || filtered

    const onClear = () => {
        let updatedPage = {...page}
        updatedPage['group'] = null
        updatedPage['sort'] = null
        updatedPage['filters'] = null
        dispatch(actionCreators.updatePage(updatedPage, data, uid, sessionId))
    }

    return(
        <Container>
            <AnimateSharedLayout>
                <motion.div layout='position'>
                    <Button text={page['group'] ? `Group:${groupContext[page['group']]['title']}` : 'Group'} icon={<FaObjectUngroup/>}
                        styles={page['group'] ? selectedStyle : buttonStyle}
                        contextMenu={<GroupOptions pageID={pageID}/>}/>
                </motion.div>

                <motion.div layout='position'>
                    <Button text={page['sort'] && page['sort']['value'] ? `Sort:${sortContext[page['sort']['value']]['title']}` : 'Sort'} 
                        styles={page['sort'] && page['sort']['value'] ? selectedStyle : buttonStyle}
                        icon={page['sort'] && page['sort']['direction'] === 'DESCENDING' ? <FaSortAmountUpAlt/> : <FaSortAmountUp/>}
                        contextMenu={<SortOptions pageID={pageID}/>}/>
                </motion.div>

                <motion.div layout='position'>
                    <Button text='Filter' icon={<FaFilter/>}
                        styles={filtered ? selectedStyle : buttonStyle}
                        contextMenu={<FilterOptions pageID={pageID}/>}/>
                </motion.div>

                <motion.div layout>{showClear && <Button tooltip='Reset' icon={<FaSyncAlt/>}onSelect={onClear} styles={clearStyle}/>}</motion.div>
                {/* <AnimatePresence>
                    {showClear ? <Animation animation='default'><Button text='Reset' onSelect={onClear} styles={clearStyle}/> </Animation> : null}
                </AnimatePresence>
                     */}
            </AnimateSharedLayout>
            

            

            
            
            
        </Container>
    )
}

export default ViewControl